module.exports = __webpack_public_path__ + "static/media/FAcebook.54c2e8c3.svg";